var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_972_474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6277 32.1421C25.4711 32.1421 32.6402 24.9731 32.6402 16.1297C32.6402 7.28621 25.4711 0.117188 16.6277 0.117188C7.78426 0.117188 0.615234 7.28621 0.615234 16.1297C0.615234 24.9731 7.78426 32.1421 16.6277 32.1421Z",
    fill: "url(#paint0_linear_972_474)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84854 15.9546C12.5126 13.9094 15.6303 12.5875 17.2016 11.939C21.6412 10.0933 22.5641 9.76908 23.1627 9.74414C23.2874 9.74414 23.5867 9.76908 23.7862 9.91873C23.9358 10.0434 23.9857 10.218 24.0107 10.3427C24.0356 10.4674 24.0605 10.7418 24.0356 10.9663C23.7862 13.4854 22.7636 19.6459 22.2149 22.4643C21.9904 23.6615 21.5415 24.0606 21.1174 24.1105C20.1946 24.1853 19.4713 23.4869 18.5734 22.9133C17.1767 21.9904 16.3786 21.4168 15.0068 20.5189C13.4354 19.4713 14.4581 18.8977 15.3559 17.9749C15.5804 17.7254 19.6958 14.0091 19.7706 13.66C19.7706 13.6101 19.7955 13.4604 19.6958 13.3856C19.596 13.3108 19.4713 13.3357 19.3715 13.3607C19.2219 13.3856 16.9771 14.8821 12.6124 17.8252C11.9639 18.2741 11.3902 18.4737 10.8665 18.4737C10.2928 18.4737 9.19539 18.1494 8.37232 17.8751C7.37465 17.5508 6.57652 17.3763 6.65135 16.8275C6.70123 16.5532 7.1003 16.2539 7.84854 15.9546Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_972_474",
    x1: 0.615234,
    y1: 16.1181,
    x2: 32.617,
    y2: 16.1181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_972_474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.615234 0.117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.44be1103142148a781ed22159977b216.svg";
export { ForwardRef as ReactComponent };